import Vue from 'vue'
import Router from 'vue-router'
import Branches from './views/Branches.vue'
import Branch from './views/Branch.vue'
import QueueInfo from './views/QueueInfo'
import BranchQueueInfo from './views/BranchQueueInfo'
import Cancel from './views/Cancel'
import CancelAll from './views/CancelAll'
import CancelAllSummary from './views/CancelAllSummary'
import Checkin from './views/Checkin'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'branches',
            component: Branches
        },
        {
            path: '/queueinfo',
            name: 'queueinfo',
            component: QueueInfo
        },
        {
            path: '/branch/:id',
            name: 'branch',
            component: Branch,
            props: true
        },
        {
            path: '/branch/:id/branchqueueinfo',
            name: 'branchqueueinfo',
            component: BranchQueueInfo,
            props: true
        },
        {
            path: '/cancel/:hash',
            name: 'cancel',
            component: Cancel,
            props: true
        },
        {
            path: '/cancelall/',
            name: 'cancelall',
            component: CancelAll,
            props: true
        },
        {
            path: '/cancelall/:hash',
            name: 'cancelallsummary',
            component: CancelAllSummary,
            props: true
        },
        {
            path: '/checkin/:hash',
            name: 'checkin',
            component: Checkin,
            props: true
        }
    ]
});

export default router;